import React from 'react';

interface BottomPanelContainerProps {
  children: React.ReactNode;
  justifyContent?: 'space-between' | 'flex-start' | 'flex-end' | 'center';
}

//TODO: use css class (directly or through react-admin) instead of style (to reduce html/css text)
export const BottomPanelContainer: React.FC<BottomPanelContainerProps> = ({
  children,
  justifyContent = 'space-between',
}) => {
  return (
    <div style={{
      position: 'absolute',
      width: "100%",
      boxSizing: "border-box",
      bottom: 0,
      display: 'flex',
      justifyContent,
      alignItems: 'flex-end',
      padding: '10px',
      pointerEvents: 'none',
    }}>
      {children}
    </div>
  );
};
